var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"title",attrs:{"src":require("@/assets/img/title.png"),"alt":"智能云服务"}}),_c('van-button',{attrs:{"type":"info","size":"large","round":""},on:{"click":_vm.jump}},[_vm._v("跳转小程序")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }